const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/**
 * A `YYYY-MM-DD` date in the review list's short form ("Mar 15").
 *
 * Empty for a null or empty date; any other shape is returned unchanged.
 */
export function formatShortDate(dateStr: string | null): string {
  if (!dateStr) return "";
  const parts = dateStr.split("-");
  if (parts.length !== 3) return dateStr;
  const monthIndex = parseInt(parts[1] ?? "0", 10) - 1;
  const day = parseInt(parts[2] ?? "0", 10);
  return `${MONTH_NAMES[monthIndex] ?? ""} ${day}`;
}

const FULL_MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/**
 * A `YYYY-MM-DD` date spelled out ("February 28, 2026"), the way the upload
 * answer's server sentence writes its dates (walk-through round 1).
 *
 * Empty for a null or empty date; any other shape is returned unchanged.
 */
export function formatLongDate(dateStr: string | null): string {
  if (!dateStr) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
  const month = match ? FULL_MONTH_NAMES[parseInt(match[2] ?? "0", 10) - 1] : undefined;
  if (!match || !month) return dateStr;
  return `${month} ${parseInt(match[3] ?? "0", 10)}, ${match[1] ?? ""}`;
}
